module.exports = __webpack_public_path__ + "img/appartment.4ccf0842.png";